
const SCROLL_TO_ELEMENT = 'scroll-to-element';

export {
  SCROLL_TO_ELEMENT
};
